<template>
  <Content class="col-span-full" :title="$route.name">
    <Notice class="mb-8">
      {{ $t('ROUTING_HISTORY_REPORT_NOTE') }}
    </Notice>
    <!-- <tripsTable :tableData="tableData.results" :alpha="alphaList" /> -->

    <RoutingForm
      @path="path = $event"
      @realtime="realtime = $event"
      @anomaly="anomalyPoints = $event"
    />

    <RoutingMap v-show="path != null" :tripDetail="path" :realtime="realtime" />
    <Content
      class="col-span-full mt-8"
      childClass="border-whitee"
      title="SPEED_GRAPH"
      :showBreadcrumb="false"
      :showAdd="false"
      v-if="path != null"
    >
      <VueApexCharts
        type="line"
        height="350"
        :options="{
          chartOptions,
          labels: date,
          annotations: {
            yaxis: [
              // {
              //   y: path.speeds.max_speed,
              //   borderColor: '#b30000',
              //   label: {
              //     borderColor: '#b30000',
              //     textAnchor: 'start',
              //     style: {
              //       color: '#fff',
              //       background: '#b30000',
              //     },
              //     text: `${$t('MAX_SPEED')}: ${path.speeds.max_speed}km/h`,
              //   },
              // },
              // {
              //   y: path.speeds.avg_speed,
              //   borderColor: '#d0aa00',
              //   label: {
              //     borderColor: '#d0aa00',
              //     textAnchor: 'start',
              //     style: {
              //       color: '#fff',
              //       background: '#d0aa00',
              //     },
              //     text: `${$t('AVG_SPEED')}: ${path.speeds.avg_speed}km/h`,
              //   },
              // },
            ],
          },
          points: [
            {
              x: new Date('01 Dec 2017').getTime(),
              y: path.max_speed,
              marker: {
                size: 8,
                fillColor: '#fff',
                strokeColor: 'red',
                radius: 2,
                cssClass: 'apexcharts-custom-class',
              },
              label: {
                borderColor: '#FF4560',
                offsetY: 0,
                style: {
                  color: '#fff',
                  background: '#FF4560',
                },

                text: 'Point Annotation',
              },
            },
          ],
        }"
        :series="speeds"
      ></VueApexCharts>
    </Content>
  </Content>
</template>
<script>
import Notice from '@/components/elements/notice'
// import { trips } from "@/api/reports";
import tripsTable from '@/components/reports/history/tripsTable'
import { licenseChars } from '@/api/global'
import RoutingForm from '@/components/reports/history/RoutingForm'
import RoutingMap from '@/components/reports/history/RoutingMap.vue'
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    tripsTable,
    RoutingForm,
    RoutingMap,
    Notice,
    VueApexCharts,
  },
  data() {
    return {
      chartOptions: {
        chart: {
          height: 350,
          locales: ['fa'],
          defaultLocale: 'fa',
          type: 'line',
          id: 'areachart-2',
          fontFamily: 'Vazir',
        },
        annotations: {
          yaxis: [],
          xaxis: [],
          points: [],
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
        },
        grid: {
          padding: {
            right: 0,
            left: 0,
          },
        },
        title: {
          text: 'Line with Annotations',
          align: 'right',
        },

        xaxis: {
          type: 'datetime',
        },
      },
      tableData: [
        {
          number_of_accelerations: 0,
          number_of_brakes: 0,
          number_of_cornerings: 0,
          number_of_overspeedings: 0,
        },
      ],
      path: null,
      realtime: false,
      wrapperLoading: false,
      alphaList: [
        {
          char: '',
        },
      ],
      speeds: [
        {
          data: [],
        },
      ],
      date: [],
    }
  },
  mounted() {
    // trips.api(this.$route.query.p).then((res) => {
    //   this.wrapperLoading = false;
    //   this.tableData = res;
    // });
    licenseChars.api().then((res) => {
      this.alphaList = res
    })
  },
  watch: {
    path(val) {
      if (val) {
        this.speeds[0].data = val.speeds.map((i) => i + 'km/h')
        this.date = val['datetimes'].map((i) => {
          return (
            new Date(i).toLocaleDateString('fa-IR') +
            ' | ' +
            new Date(i).toLocaleTimeString('fa-IR')
          )
        })
      }
    },
  },
}
</script>
<style>
.border-whitee {
  border-color: white !important;
}
</style>
